module.exports = __webpack_public_path__ + "static/3-36edc0297539c692d6d146ddffeae9e7.png";